import * as React from "react";
import { Form, Input, Button, Alert } from "components/Atoms";
import * as ActionTypes     from 'constants/ActionTypes';

const LoginRegisterSuccess = ({ showLogin, serviceError, serviceCode, reqStatus }) => {
  const [form] = Form.useForm();

  return (
    <div className="form login">
      <h3>Welcome to {process.env.REACT_APP_NAME}</h3>
      <Form
        name="login-form"
        form={form}
        layout={"vertical"}
      >
      <Form.Item>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          style={{ width: "50%" }}
          onClick={showLogin}
        >
          Login
        </Button>
      </Form.Item>
      <Form.Item>
        {reqStatus === ActionTypes.REGISTER_FAILURE && (
            <Alert
                className="error-message"
                message={serviceError}
                type="error"
                description={serviceError}
                showIcon
            />
        )}
        { serviceCode !== 200 && (
            <Alert
                className="message"
                message={serviceError}
                type="error"
                showIcon
            />
        )}
      </Form.Item>
      </Form>
    </div>
  );
};

export default LoginRegisterSuccess;
